// Node
const $ = require('jquery');
require('jquery-ujs');

// Custom
import FunnySadDialog from 'new_design/common/funny-sad-dialog';


function initDirectContracts () {
  let $editCommentArea = $('.camp-comment');

  let $commentsCampOkBtn = $editCommentArea.find('#comment_ok_btn');

  let $otherContacts = $('#other_contacts');
  let $otherContactsBtn = $('#other_contacts_btn');

  let $campId = $('#direct_contacts').data('camp-id');

  $commentsCampOkBtn.on('click', function (event) {
    commentsCampDone();
  });

  const deleteComment = function () {
    if (confirm('Вы уверены, что хотите удалить комментарий?')) {
      let $comment = $(this).parent();
      let commentId = $comment.data("value");

      $.ajax({
        method: 'DELETE',
        url: window.website_prefix + `/comments/${commentId}.json`,
        success: () => {
          $comment.remove();
        },
        error: () => {
          FunnySadDialog.createSadDialog('Ошибка!', 'Не получилось удалить комментарий');
        }
      });
    }
  }

  const editComment = function () {
    let $comment = $(this).parent();
    let commentId = $comment.data("value");
    let $commentArea = $comment.children(".comment_text");

    if ($commentArea.hasClass("un_edit")) {
      let text = $commentArea.html().replaceAll("<br>", "\n", "g");
      $commentArea.replaceWith(`<textarea class="comment_text edit" rows="5" cols="66">${text}</textarea>`);
      $(this).text("ок");
    } else {
      update_comment($commentArea, commentId, $commentArea.val());
      $(this).text("Ред.");
    }
  }

  const update_comment = function (commentArea, commentId, text) {
    $.ajax({
      method: 'PUT',
      url: window.website_prefix + `/comments/${commentId}.json`,
      data: {
        new_text: text
      },
      success: () => {
        commentArea.replaceWith('<div class="comment_text un_edit">' + text.replaceAll("\n", "<br/>", "g") +'</div>');
      },
      error: () => {
        FunnySadDialog.createSadDialog('Ошибка!', 'Не получилось удалить комментарий');
      }
    });
  }

  $(".deleteCommentBtn").click(deleteComment);
  $(".editCommentBtn").click(editComment);

  $('.comment-edit').scrollTop($('.comment-edit').children().height());

  const commentsCampDone = function () {
    let $comment = $('#camp_comment');
    let $user = $(".user_info").text();
    let $commentsList = $('#comments_list');

    if ($comment.val() != '') {
      $.ajax({
        method: 'POST',
        url: window.website_prefix + `/comments.json`,
        data: {
          message: $comment.val(),
          item_id: $campId,
          item_type: 'Camp'
        },
        success: (data) => {
          let newComment = data[data.length - 1];
          $commentsList.append(`<div class="borderedOutputField" data-value="${newComment['id']}">` +
              "<button class='btn btn-default comment-btn deleteCommentBtn' title='Удалить'>x</button>" +
              "<button class='btn btn-default comment-btn editCommentBtn' title='Редактировать' style='font-size: 10px;'>Ред.</button>" +
              `<span class="camp-comment-line"> ${$user} ${newComment['created_at']} </span>` +
              `<div class="comment_text un_edit">${$comment.val().replaceAll("\n", "<br/>", "g")}</div>` +
              `<br><br> </div>`);
          $comment.val("");
          $(".deleteCommentBtn").last().click(deleteComment)
          $(".editCommentBtn").last().click(editComment);
          $('.comment-edit').scrollTop($('.comment-edit').children().last().height());
          FunnySadDialog.createFunnyDialog('Успешно!', 'Комментарий успешно добавлен');
        },
        error: () => {
          FunnySadDialog.createSadDialog('Ошибка!', 'Не получилось добавить комментарий');
        },
        complete: () => {
        }
      });
    } else {
      FunnySadDialog.createSadDialog('Ошибка!', 'Комментарий не должен быть пустым!');
    }
  }

  $otherContactsBtn.on('click', function (event) {
    event.preventDefault();
    $otherContacts.toggle(200);
  });

  $otherContacts.hide();
}

export default initDirectContracts;
